import { render, staticRenderFns } from "./NovaUnimedModal.vue?vue&type=template&id=290788d1"
import script from "./NovaUnimedModal.vue?vue&type=script&lang=js"
export * from "./NovaUnimedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports